import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "card-form" }, null, -1)
const _hoisted_3 = { name: "datos" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1)
const _hoisted_5 = { class: "mt-8" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopUpLight = _resolveComponent("PopUpLight")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.token) = $event)),
          type: "hidden",
          id: "token"
        }, null, 512), [
          [_vModelText, _ctx.token]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errorCode) = $event)),
          type: "hidden",
          id: "errorCode"
        }, null, 512), [
          [_vModelText, _ctx.errorCode]
        ])
      ])
    ]),
    _hoisted_4,
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.showBridge)
          ? (_openBlock(), _createBlock(_component_PopUpLight, {
              key: 0,
              onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showBridge= false)),
              customClass: 'width-lg'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.showPopUpMsg)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.popUpMsg), 1))
                    : _createCommentVNode("", true),
                  (_ctx.showIframe)
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 1,
                        class: "iframe",
                        title: "Payment Bridge",
                        frameborder: "0",
                        src: _ctx.iframeSrc
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}